export default class CreateRoleModel {
    groupName?: string;

    parentGroupId='';

    description?: string;

    accountType=0;

    accessRightCodes:Array<string>=[]
}
